import React, { useState } from 'react';
import hannaAmazingGif from '../assets/Q11/hanna_amazing.gif';
import hannaSmart from '../assets/Q11/hanna_smart.jpg';
import caitlynConfident from '../assets/Q11/caitlyn_confident.gif';

const TARGETS = ['AMAZING', 'CUTE', 'BEAUTIFUL'];
const POST_BEAUTIFUL_WORDS = ['HOT', 'SMART', 'BRILLIANT', 'RESILIENT', 'CAPABLE', 'WITTY', 'FUNNY', 'STRONG', 'CREATIVE', 'ADORABLE', 'KIND', 'COURAGEOUS', 'AMBITIOUS', 'ENTHUSIASTIC', 'SUPPORTIVE'];
const GREETINGS = ['Describe yourself in one word', 'Now seriously', 'Ok, now you write'];
const GIFS = [hannaAmazingGif, hannaSmart, caitlynConfident];

function Q11({ question = 11, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [phase, setPhase] = useState(0);
  const [value, setValue] = useState('');
  const [tryAgain, setTryAgain] = useState(false);
  const [postBeautifulUnlocked, setPostBeautifulUnlocked] = useState(false);
  const [postBeautifulIndex, setPostBeautifulIndex] = useState(0);
  const [currentPostBeautifulWord, setCurrentPostBeautifulWord] = useState('');

  const target = TARGETS[phase];
  const greeting = GREETINGS[phase];
  const cornerGif = GIFS[phase];

  const inputTarget = (phase === 2 && postBeautifulUnlocked) ? (currentPostBeautifulWord || POST_BEAUTIFUL_WORDS[0]) : target;

  const handleInputChange = (e) => {
    const raw = e.target.value;
    const len = Math.min(raw.length, inputTarget.length);
    setValue(inputTarget.slice(0, len));
  };

  const handleConfirm = () => {
    if (phase === 2) {
      if (!postBeautifulUnlocked) {
        if (value !== target) {
          setTryAgain(true);
          return;
        }
        setTryAgain(false);
        setPostBeautifulUnlocked(true);
        const firstWord = POST_BEAUTIFUL_WORDS[0];
        setValue(firstWord);
        setCurrentPostBeautifulWord(firstWord);
        setPostBeautifulIndex(1);
        return;
      }
      if (value === POST_BEAUTIFUL_WORDS[POST_BEAUTIFUL_WORDS.length - 1]) {
        onNavigate?.('q12');
        return;
      }
      const word = POST_BEAUTIFUL_WORDS[postBeautifulIndex];
      setValue(word);
      setCurrentPostBeautifulWord(word);
      setPostBeautifulIndex((i) => (i + 1) % POST_BEAUTIFUL_WORDS.length);
      return;
    }
    if (value !== target) {
      setTryAgain(true);
      return;
    }
    setTryAgain(false);
    setValue('');
    if (phase < TARGETS.length - 1) {
      setPhase((p) => p + 1);
    }
  };

  return (
    <div className="dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm a positive title</span>
        <h1>Project Valen</h1>
        <p>I know the answer</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q2__center">
      <span className="secretpin__title q2__greeting q11__greeting">{greeting}</span>
      <input
        type="text"
        className="dashboard__input secretpin__input q11__input"
        placeholder=""
        autoComplete="off"
        value={value}
        onChange={handleInputChange}
      />
      <button
        type="button"
        className="dashboard__button dashboard__button--primary home__button q11__button"
        onClick={handleConfirm}
      >
        {tryAgain && value !== target ? 'Try again' : 'Confirm'}
      </button>
    </div>
    {(value === target || (phase === 2 && postBeautifulUnlocked)) && (
      <img src={cornerGif} alt="" className={phase >=2 ? "q11__corner-gif" : "q11__corner-gif q11__corner-gif--small"} />
    )}
  </div>
  );
}

export default Q11;
